import { render, staticRenderFns } from "./RegistrationStipulation.vue?vue&type=template&id=b5e2e93e&"
import script from "./RegistrationStipulation.vue?vue&type=script&lang=js&"
export * from "./RegistrationStipulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports